import api from './base';
import { AxiosRequestConfig } from 'axios';

import { GetListType } from './types/GetListType';
import { VisitFlowTypesModel } from '@w3lcome/types';

class VisitFlowTypesApi {
  public getVisitFlowTypes = async (params: any, config?: AxiosRequestConfig) => {
    try {
      const { data } = await api.get<GetListType<VisitFlowTypesModel>>(`/visit-flow-types`, {
        ...config,
        params,
      });

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}

export default new VisitFlowTypesApi();
